import React from 'react';
import s from './grid.module.scss';
import { getGridColumnsCount } from './grid.utils';
export function Grid({ dataHook, columns: maxColumns, minColumns = 1, rows: maxRows, finalColumnsCount, children, skin = 'default', }) {
    const gridRef = React.useRef(null);
    React.useEffect(() => {
        if (gridRef.current) {
            const columnsCount = getGridColumnsCount(gridRef.current);
            finalColumnsCount?.(columnsCount);
        }
    }, [gridRef.current]);
    return (React.createElement("div", { ref: gridRef, "data-hook": dataHook, className: `${s.gridContainer} ${skin === 'slim' ? s.slimGrid : ''}`, style: {
            '--grid-min-columns': minColumns,
            '--grid-max-columns': maxColumns,
            ...(maxRows && { '--grid-max-rows': maxRows }),
            ...(maxColumns === 1 && {
                '--grid-gap': '18px',
                '--grid-item-min-width': '250px',
            }),
            ...(skin === 'slim' && {
                '--grid-item-min-width': '237px',
                '--grid-gap': '18px',
            }),
        } }, children));
}
//# sourceMappingURL=grid.js.map